// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef08b1bb","488":"fefb965c","732":"c3d46fa3","977":"5a1617dd"}[chunkId] + ".chunk.js";
};